var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"echarts"},[_c('IEcharts',{attrs:{"option":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }